import { render, staticRenderFns } from "./transBoutique.vue?vue&type=template&id=15835d22&scoped=true&"
import script from "./transBoutique.vue?vue&type=script&lang=js&"
export * from "./transBoutique.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./transBoutique.vue?vue&type=style&index=0&id=15835d22&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "15835d22",
  "76a2bc06"
  
)

export default component.exports